export const API_URL = process.env.REACT_APP_REMOTE_API;

export const FRESHDESK_WIDGET_ID: string = process.env.REACT_APP_FRESHDESK_WIDGET_ID!

export const FRESHDESK_WIDGET_URL: string = process.env.REACT_APP_FRESHDESK_WIDGET_URL!

export default API_URL;
